define(function(require, exports, module) {
    'use strict';

    var core = require('core');
    var url = require('util/url.util');
    var config = require('config');
    var MenuView = require('modules/menu/menu.view');

    module.exports = MenuView.extend({
        events: Object.assign({}, MenuView.prototype.events, {
            'tap .fn-btn-signUp': 'handleRegisterOnMainClick'
        }),

        handleRegisterOnMainClick: function(event) {
            const currentUrl = url.friendlyUrl;
            const rootUrl = url.getFriendlyUrl(config.get('rootPage'));
            const isMainPage = currentUrl === rootUrl || currentUrl === '' ;
            const urlParam = '?clientType=sportsbook';
            const registrationUrl = config.get('registrationURL');

            if (isMainPage) {
                event.preventDefault();
                core.navigate(`${registrationUrl}${urlParam}`);
            } else {
                core.navigate(`${registrationUrl}`);
            }
        }
    });
});
